  <sm-title-bar [headerCustomTemplate]="addButton" [pageTitle]="trackerName + ' tracking'" [back]="true">
    <ng-template #addButton>
      <div class="d-flex search-field">
        <div class="create_btn_sd">
          <button mat-button color="accent" (click)="addrecorddata()">
              <mat-icon>add</mat-icon> 
              Record data
          </button>
      </div>
      </div>
    </ng-template>
  </sm-title-bar>

<mat-card *ngIf="!loader">
    <div class="rounded-3 bg-light">
      <sm-data-table [columnHeaders]="tableDisplayColumns" [dataSource]="progressData" [showMenuButton]="true" [menuDropdownTemplate]="menuTemplate"
         >
      </sm-data-table>
    </div>
  <ng-template #menuTemplate let-rowvalue>
  
    <button mat-menu-item (click)="deleteItem(rowvalue)" [disabled]="rowvalue.creator_type != 2 || rowvalue.created_by != employeeHash">
      <mat-icon class="material-icons-outlined">delete</mat-icon>
      <span>Delete</span>
    </button>

  </ng-template>
  </mat-card>


   <div class="create_btn_delete" *ngIf="!loader">
          <button mat-button color="accent" (click)="deleteTracker()" *ngIf="ciot.creator_type == 2 && ciot.created_by == employeeHash">
              <mat-icon class="material-icons-outlined">delete</mat-icon>
             Delete tracking
          </button>
      </div>


  